import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Td,
  Text,
  Tr,
  useDisclosure,
  Collapse,
  Card,
  CardBody,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import {
  DropdownInput,
  PrimaryButton,
  PrimaryInput,
  Toaster,
} from "../../components";
import {
  actionAccessMain,
  formatDate_YYYY_MM_DD,
  getBranchId,
  getLoginID,
  useScreenType,
  validationOfNumberWithOnly1Decimal,
} from "../../auth";
import {
  AddGenericMedicine,
  DeleteGenericMedicine,
  EditGenericMedicine,
  FetchFilteredGenericMedicinesList,
  FetchGenericMedicinesList,
} from "../../middleware/services/drugdatabasemanagement";
import SimpleTable from "../../components/simple-table";
import { add } from "date-fns";
import DynamicModal from "../../components/dynamic-modal";
import MiniDropdownInput from "../../components/mini-dropdown";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";

const DrugDatabaseManagement = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  let [pageno, setPageno] = useState(1);
  const [showFilterCount, setShowFilterCount] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [countTo, setCountTo] = useState(0);
  const [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  const [countFrom, setCountFrom] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [genericMedicineView, setGenericMedicineView] = useState([]);
  const [medicineType, setMedicineType] = useState();
  const [dosage, setMedicineDosage] = useState(null);
  const [medicineId, setMedicineId] = useState(null);
  const [composition, setComposition] = useState(null);
  const [therapeutic, setTherapeutic] = useState(null);
  const [drugClass, setDrugClass] = useState(null);
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [dosageMl, setDosageMl] = useState("mg");
  const [filterMedicinetype, setFilterMedicinetype] = useState("");
  const { showSuccessToast, showErrorToast } = Toaster();
  const screenType = useScreenType();
  const { isOpen, onToggle } = useDisclosure();
  let itemPerPageCommonValue = 50;

  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  const [actionAccess, setActionAccess] = useState(null);
  const [search, setSearch] = useState({
    id: "",
    composition: "",
    strength: "",
    type: "",
    drugClass: "",
    therapeutic: "",
  });

  const addgeneric = React.useRef(null);
  const editgeneric = React.useRef(null);
  const deletegeneric = React.useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, "name");
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (selectedOption) => {
    setMedicineType(selectedOption);
    setFilterMedicinetype(selectedOption);
  };

  const handleApplyFilters = () => {
    setShowFilterCount(true);
    setPageno(1);
    setCurrentPage(1);
    getFilteredResults();
  };

  const resetFields = () => {
    setPageno(1);
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1);
    setCountTo(itemPerPageCommonValue);
    setCurrentPage(1);
    setShowFilterCount(false);
    setFilterMedicinetype("");
    setTherapeutic("");
    setDrugClass("");
    setSearch({
      id: "",
      composition: "",
      strength: "",
      type: "",
      drugClass: "",
      therapeutic: "",
    });
    setRefresh(!refresh);
  };

  const handleChangeDosageUnit = (selectedOption) => {
    setMedicineDosageUnit(selectedOption.label);
  };
  const handleChangeDosageMl = (selectedOption) => {
    setDosageMl(selectedOption.label);
  };

  const getFilteredResults = () => {
    const tableContainer = document.querySelector(".tableContainer");
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();

    var input = {
      chemicalcomposition: search.composition?.trim() || null,
      searchtext: null,
      dosage: search.strength?.trim() || null,
      medicinetype: filterMedicinetype || null,
      // medicinetype: search.type?.trim() || null,
      drugclass: search.drugClass?.trim() || null,
      therapeutic: search.therapeutic?.trim() || null,
      startdate: null,
      enddate: null,
      pageno: pageno,
      pagesize,
    };
    var getMedicinesList = async () => {
      try {
        var result = await FetchGenericMedicinesList(input);
        if (result?.data) {
          setGenericMedicineView(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count);
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          setTotalPages(totalPagesCount);
          setTotalItemCount(result.count);
          if (count < itemPerPageCommonValue) {
            setCountTo(count);
            setTotalExceedsPageCount(true);
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setGenericMedicineView([]);
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getMedicinesList();
  };
    useEffect(()=>{
      if(pageno){
        
         getFilteredResults();
         }
    },[pageno])

  useEffect(() => {
    setActionAccess(actionAccessMain(6));
    showLoader();
    var input = {
      pageno: 1,
      pagesize,
    };
    var getMedicinesList = async () => {
      try {
        var result = await FetchGenericMedicinesList(input);
        // console.log(result, "genericMedicineView");
        if (result?.data) {
          setGenericMedicineView(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count);
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);

          setTotalPages(totalPagesCount);

          setTotalItemCount(count);
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count);
            setTotalExceedsPageCount(true);
          } else if (result.count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setGenericMedicineView([]);
        }
      } catch (error) {
        console.error("Error in home:", error);
      }
      dismissLoader();
    };

    getMedicinesList();
  }, [refresh]);

  const openAddGeneric = () => {
    setMedicineDosage("");
    setComposition("");
    setDrugClass("");
    setTherapeutic("");
    addgeneric.current.openModal();
  };
  const openEditGeneric = (medicine) => {
    setMedicineId(medicine.id || "");
    setComposition(medicine.chemicalcomposition || "");
    setMedicineDosage(medicine.dosage || "");
    setMedicineDosageUnit(medicine.dosageunit || "");
    setMedicineType(medicine.medicinetype || "");
    setDrugClass(medicine.drugclass || ""); 
    setTherapeutic(medicine.therapeutic || "");
    editgeneric.current.openModal();
  };
  const openDeleteGeneric = (medicine) => {
    setSearch({
      id: medicine.id || "",
    });
    setComposition(medicine.chemicalcomposition || "");
    deletegeneric.current.openModal();
  };
  const addNewGenericMedicine = async () => {
    if (!composition || composition.trim() === "") {
      return showErrorToast("Please enter the chemical composition.");
    }
    if (!dosage || dosage.trim() === "") {
      return showErrorToast("Please enter the dosage.");
    }
    if (!dosageunit || dosageunit.trim() === "") {
      return showErrorToast("Please select a dosage unit.");
    }
    if (!medicineType || medicineType.trim() === "") {
      return showErrorToast("Please select a medicine type.");
    }

    const input = {
      chemicalcomposition: composition,
      dosage: dosage,
      dosageunit: dosageunit,
      medicinetype: medicineType,
      drugclass: drugClass || null,
      therapeutic: therapeutic || null,
    };
    try {
      const result = await AddGenericMedicine(input);
      console.log(result, "add result");
      if (result) {
        showSuccessToast("Medicine created Successfully");
        addgeneric.current.closeModal();
        setSearch({
          id: "",
          composition: "",
          strength: "",
          type: "",
          drugClass: "",
        });
        setMedicineDosage("");
        setRefresh(!refresh);
      }
    } catch (error) {
      console.error("Failed to create medicine:", error);
      showErrorToast("Failed to create medicine.");
    }
  };

  const editGenericMedicine = async () => {
    const input = {
      id: medicineId,
      chemicalcomposition: composition,
      dosage: dosage,
      dosageunit: dosageunit,
      medicinetype: medicineType,
    };

    try {
      const result = await EditGenericMedicine(input);
      if (result) {
        showSuccessToast("Generic medicine updated successfully");
        editgeneric.current.closeModal();
        setRefresh(!refresh);
      }
    } catch (err) {
      showErrorToast("Update failed");
    }
  };
  const deleteGenericMedicine = async (medicine) => {
    const result = await DeleteGenericMedicine({
      id: medicine,
      loginid: getLoginID(),
    });
    console.log(result, "delete result");
    if (result.output.message == "Successfully Updated") {
      showSuccessToast("Medicine deleted successfully");
      deletegeneric.current.closeModal();
      setRefresh(!refresh);
    }
  };

  const handleNextClick = () => {
    let page = pageno + 1;
    setPageno(page);
    setCurrentPage(currentPage + 1);
    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;
    setPageno(page);
    setCurrentPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const medicineTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Injection",
    "Ointments / Creams / Gels",
    "Drops",
    "Nebulization",
    "IVFluids",
    "Inhaler",
  ];

  // const rawTypes =
  //   genericMedicineView?.length > 9
  //     ? genericMedicineView.map((item) => item.medicinetype).filter(Boolean)
  //     : medicineTypes;

  // const uniqueMedicineTypes = Array.from(new Set(rawTypes));

  const getOptionsByType = (type) => {
    switch (type) {
      case "Tablet":
      case "Capsule":
        return [
          { label: "mg", value: "mg" },
          { label: "mcg", value: "mcg" },
          { label: "g", value: "g" },
        ];
      case "Inhaler":
        return [
          { label: "puffs", value: "puffs" },
          { label: "ml", value: "ml" },
          { label: "grms", value: "grms" },
        ];
      case "Syrup":
      case "Injection":
      case "Nebulization":
      case "IVFluids":
      case "Drops":
        return [{ label: "ml", value: "ml" }];
      default:
        return [
          { label: "mg", value: "mg" },
          { label: "ml", value: "ml" },
          { label: "grms", value: "grms" },
        ];
    }
  };

  const placeholder =
    ["Syrup", "Injection", "Nebulization", "IVFluids", "Drops"].includes(
      medicineType
    ) || medicineType === "Inhaler"
      ? "Volume"
      : "Strength";

  const handlemedicinetypechange = (event) => {
    setMedicineType(event);
    if (event == "Tablet" || event == "Capsule") {
      setMedicineDosageUnit("mg");
    } else if (
      event == "Syrup" ||
      event == "Injection" ||
      event == "Nebulization" ||
      event == "IVFluids" ||
      event == "Drops"
    ) {
      setMedicineDosageUnit("ml");
    } else if (event == "Ointment") {
      setMedicineDosageUnit("grms");
    } else if (event == "Inhaler") {
      setMedicineDosageUnit("puffs");
    }
  };
  const TableHeader = [
    { key: "composition", label: "Composition (API)" },
    { key: "drugclass", label: "Drug class" },
    { key: "therapeutic", label: "Therapeutic" },
    { key: "strength", label: "Strength" },
    // { key: "type", label: "Type" },
    { key: "actions", label: "Actions" },
  ];

  const gobackfunction = ()=>{
    window.history.back();
   }
  return (
    <>
      {screenType == "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            {isLoading && <Loader />}
            <Box w="100%">
              <SecondaryNav withBack="Generic Drug Database Management" goBack={gobackfunction} />

              <Box
                gap="10px"
                w="100%"
                p="1rem"
                display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
              >
                <PrimaryInput
                  variant="fullRound"
                  title="Search by Composition"
                  inputPlace="Composition"
                  name="composition"
                  // onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  inputValue={search.composition}
                />
                <PrimaryInput
                  variant="fullRound"
                  title="Search by Strength"
                  inputPlace="Strength"
                  name="strength"
                  // onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  inputValue={search.strength}
                />
                <PrimaryInput
                  variant="fullRound"
                  title="Search by Drug Class"
                  inputPlace="Drug Class"
                  name="drugClass"
                  // onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  inputValue={search.drugClass}
                />
                <PrimaryInput
                  variant="fullRound"
                  title="Search by Therapeutic"
                  inputPlace="Therapeutic Category"
                  name="therapeutic"
                  // onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  inputValue={search.therapeutic}
                />
                <DropdownInput
                  variant="fullSide"
                  dropDownPlace="Type"
                  options={medicineTypes}
                  // options={uniqueMedicineTypes}
                  onClick={(selectedOption) =>
                    handleDropdownChange(selectedOption)
                  }
                  value={filterMedicinetype}
                />
                <Box
                  gap="10px"
                  pl="1rem"
                  w="70vw"
                  display="flex"
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    onClick={handleApplyFilters}
                    btnStyle={{ m: "0" }}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtnFull"
                    btnStyle={{ color: "#AA2F27", m: "0" }}
                    onClick={resetFields}
                  />
                  <PrimaryButton
                    buttonText="Add"
                    onClick={openAddGeneric}
                    btnStyle={{ m: 0 }}
                    isDisabled={
                      actionAccess && !actionAccess.create ? true : false
                    }
                  />
                </Box>
              </Box>

              <Box w="100%" borderTop="1px solid #e2e2e2">
                <SimpleTable
                  headers={TableHeader}
                  className="tableContainer"
                  isDataPresent={true}
                  currentPage={currentPage}
                  // onPageChange={handlePageChange}
                  tableHeader={{ pos: "sticky", top: "0", bg: "white" }}
                  footerStyle={{
                    pos: "fixed",
                    bottom: "0",
                    boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    zIndex: "99",
                    width: "100%",
                  }}
                  tableStyle={{
                    maxH: "calc(100vh - 220px)",
                    overflowY: "auto",
                    tableLayout: "fixed",
                    width: "100%",
                    h: "100%",
                  }}
                  tableBody={
                    <>
                      {genericMedicineView &&
                        genericMedicineView.map((medicine, index) => (
                          <Tr w="100%" key={index}>
                            <Td maxW="200px">
                              <Box display='flex' gap='0.5rem'>
                                <Box
                                  as="p"
                                  className="textOverflow"
                                  fontWeight={"semibold"}
                                  textAlign={"left"}
                                >
                                  {medicine.chemicalcomposition
                                    ? medicine.chemicalcomposition
                                    : "-"}
                                </Box>
                                    <Box as="span" bg='#E6E7E966' mr='0.25rem' border='1px solid #E6E7E9' borderRadius='12px' fontSize='10px' p='0.25rem'>
                                      {medicine.medicinetype ? medicine.medicinetype : "-"}
                                    </Box>
                              </Box>
                            </Td>

                            <Td maxW="200px">
                              <Text isTruncated title={medicine.drugclass}>
                                {" "}
                                {medicine.drugclass
                                  ? medicine.drugclass
                                  : "-"}{" "}
                              </Text>
                            </Td>
                            <Td maxW="200px" isTruncated title={medicine.therapeutic}>
                              <Text>
                                {" "}
                                {medicine.therapeutic
                                  ? medicine.therapeutic
                                  : "-"}{" "}
                              </Text>
                            </Td>
                            <Td maxW="200px">
                              <Text>
                                {" "}
                                {medicine.dosage ? medicine.dosage : "-"}{" "}
                                {medicine.dosageunit ? medicine.dosageunit : ""}
                              </Text>
                            </Td>

                            {/* <Td maxW="150px">
                              <Text>
                                {medicine.medicinetype
                                  ? medicine.medicinetype
                                  : "-"}
                              </Text>
                            </Td> */}

                            <Td maxW="130px" pos="relative">
                              <Menu>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={9}
                                  pos="relative"
                                  right="-33px"
                                  minW="125px"
                                >
                                  <MenuItem
                                    onClick={() => openEditGeneric(medicine)}
                                    isDisabled={
                                      actionAccess && !actionAccess.update
                                        ? true
                                        : false
                                    }
                                  >
                                    Edit
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => openDeleteGeneric(medicine)}
                                  >
                                    Delete
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                          </Tr>
                        ))}
                    </>
                  }
                  footerSection={
                    <>
                      <Tr w="100%">
                        <Td colSpan={7} w="calc(100vw - 6.5rem)">
                          <Box
                            w="100%"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box
                              visibility={
                                totalItemCount < countTo &&
                                !totalExceedsPageCount
                                  ? "hidden"
                                  : "visible"
                              }
                            >
                              <Text>
                                Showing <b>{countFrom}</b> to <b>{countTo}</b>{" "}
                                of {totalItemCount} results
                              </Text>
                            </Box>

                            <Box
                              gap="2.5rem"
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Box
                                as="button"
                                onClick={handlePrevClick}
                                disabled={currentPage === 1}
                                visibility={
                                  currentPage === 1 ? "hidden" : "visible"
                                }
                                p="0.5rem 0.75rem"
                                border="0.0625rem solid #E6E7E9"
                                borderRadius="0.75rem"
                                fontSize="1rem"
                                fontWeight="500"
                              >
                                Previous
                              </Box>
                              <Box>
                                <Text
                                  textAlign="center"
                                  fontSize=".875rem"
                                  fontWeight="600"
                                >
                                  Page {currentPage} of {totalPages}
                                </Text>
                              </Box>
                              {totalItemCount >= countTo &&
                                !totalExceedsPageCount && (
                                  <Box
                                    as="button"
                                    p="0.5rem 0.75rem"
                                    mr="2.5rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    onClick={handleNextClick}
                                    disabled={currentPage === totalPages}
                                    visibility={
                                      currentPage === totalPages
                                        ? "hidden"
                                        : "visible"
                                    }
                                    fontSize="1rem"
                                    fontWeight="500"
                                  >
                                    Next
                                  </Box>
                                )}
                            </Box>
                          </Box>
                        </Td>
                      </Tr>
                    </>
                  }
                />
              </Box>
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Generic Drug Database Management"
            handlebackarrow={false}
          />

          <Box
            w="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1rem"
            gap="0.75rem"
          >
            <PrimaryInput
              variant="fullRound"
              title="Search by Composition"
              inputPlace="Composition"
              name="composition"
              // onKeyDown={handleKeyDown}
              onChange={handleInputChange}
              inputValue={search.composition}
            />
            <Box onClick={onToggle}>
              <Image
                w="50px"
                cursor="pointer"
                src={
                  isOpen
                    ? "assets/svgs/outline-f.svg"
                    : "assets/svgs/filled-f.svg"
                }
              />
            </Box>
            <PrimaryButton
              buttonText="Add"
              onClick={openAddGeneric}
              variant="mdBtn"
              isDisabled={actionAccess && !actionAccess.create ? true : false}
            />
          </Box>

          <Collapse
            in={isOpen}
            animateOpacity
            zIndex="9999"
            pos="relative"
            style={{ overflow: "visible" }}
          >
            <Box
              w="100%"
              display="flex"
              p="1rem"
              pt="0"
              flexDir="column"
              zIndex="9999"
              pos="relative"
              gap="10px"
            >
              <PrimaryInput
                variant="fullRound"
                title="Search by Strength"
                inputPlace="Strength"
                name="strength"
                // onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                inputValue={search.strength}
              />
              <DropdownInput
                variant="fullSide"
                dropDownPlace="Type"
                options={medicineTypes}
                // options={uniqueMedicineTypes}
                onClick={(selectedOption) =>
                  handleDropdownChange(selectedOption)
                }
                value={filterMedicinetype}
              />
            </Box>

            <Box w="100%" p="1rem" pt="0" display="flex" gap="10px">
              <PrimaryButton
                buttonText="Filter"
                btnStyle={{ w: "100%" }}
                id="filterButton"
                variant="mdBtn"
                onClick={handleApplyFilters}
              />
              <PrimaryButton
                buttonText="Reset"
                id="resetButton"
                variant="grayBtn"
                btnStyle={{ color: "#AA2F27", w: "100%" }}
                onClick={resetFields}
              />
            </Box>
          </Collapse>

          <Box
            h="calc(100vh - 200px)"
            overflow="hidden auto"
            border="1px solid #E6E7E9"
            p="1rem"
            display="flex"
            gap="0.75rem"
            flexDir="column"
          >
            {genericMedicineView &&
              genericMedicineView.map((medicine, index) => (
                <Card
                  borderRadius="12px"
                  key={index}
                  w="100%"
                  border="1px solid #E6E7E9"
                  boxShadow="0px 8px 20px 0px #E6E7E966"
                  h="min-content"
                >
                  <CardBody
                    p={{ base: "0.875rem", lg: "0.875rem", xl: "1.25rem" }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb="0.75rem"
                    >
                      <Box
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        flex="1"
                        minW="0"
                      >
                        <Box display="flex" flex="1" minW="0">
                          <Text
                            fontSize="15px"
                            fontWeight="600"
                            isTruncated
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            title={`${medicine.medicinename} (${
                              medicine.dosage
                            }${" "} ${" "}`}
                            maxW="100%"
                          >
                            {medicine.chemicalcomposition
                              ? medicine.chemicalcomposition
                              : "-"}
                          </Text>
                        </Box>
                      </Box>

                      <Box display="flex" width="auto" minW="1rem" gap="10px">
                        <Menu isLazy>
                          <MenuButton as="button" zIndex={99}>
                            <Image
                              w="1rem"
                              src="/assets/svgs/more-options.svg"
                              transform="rotate(90deg)"
                            />
                          </MenuButton>
                          <MenuList
                            zIndex={9}
                            pos="relative"
                            right="0px"
                            minW="125px"
                          >
                            <MenuItem
                              onClick={() => openEditGeneric(medicine)}
                              isDisabled={
                                actionAccess && !actionAccess.update
                                  ? true
                                  : false
                              }
                            >
                              Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => openDeleteGeneric(medicine)}
                              isDisabled={
                                actionAccess && !actionAccess.update
                                  ? true
                                  : false
                              }
                            >
                              Delete
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Box>
                    </Box>
                    <Flex w="100%" mb="0.75rem" justifyContent="space-between">
                      <Box display="flex" flexDir="column" w={"100%"}>
                        <Text fontSize="10px" color="gray.500">
                          Composition (API)
                        </Text>
                        <Text fontSize="12px" fontWeight="600">
                          {medicine.dosage ? medicine.dosage : "-"}{" "}
                          {medicine.dosageunit ? medicine.dosageunit : ""}
                        </Text>
                      </Box>
                      <Box display="flex" flexDir="column" w={"100%"}>
                        <Text fontSize="10px" color="gray.500">
                          Strength
                        </Text>
                        <Text fontSize="12px" fontWeight="600">
                          {medicine.dosage ? medicine.dosage : "-"}{" "}
                          {medicine.dosageunit ? medicine.dosageunit : ""}
                        </Text>
                      </Box>
                    </Flex>

                    <Flex w="100%">
                      <Box w="100%" display="flex" flexDir="column">
                        <Text fontSize="10px" color="gray.500">
                          Type
                        </Text>

                        <Text fontSize="12px" fontWeight="600">
                          {medicine.medicinetype ? medicine.medicinetype : "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </CardBody>
                </Card>
              ))}
          </Box>
        </>
      )}
      <DynamicModal
        ref={addgeneric}
        modalWidth={{ base: "100vw", lg: "calc(100vw - 50%)" }}
        modalHeader="Add Generic Medication"
        modalBody={
          <>
            <Box display="flex" flexDir="column">
              <PrimaryInput
                // variant="leftSide"
                title="Composition (API)"
                inputPlace="Composition (API)"
                name="composition"
                onChange={(e) => setComposition(e.target.value)}
                inputValue={composition}
              />
              <RadioGroup
                mt="1rem"
                defaultValue={"Tablet"}
                onChange={handlemedicinetypechange}
              >
                <Stack direction="row" gap="20px" wrap="wrap">
                  {[
                    "Tablet",
                    "Capsule",
                    "Syrup",
                    "Injection",
                    "Ointment",
                    "Drops",
                    "Nebulization",
                    "IVFluids",
                    "Inhaler",
                  ].map((type) => (
                    <Radio key={type} colorScheme="green" value={type}>
                      {type === "Ointment" ? "Ointments / Creams / Gels" : type}
                    </Radio>
                  ))}
                </Stack>
              </RadioGroup>
              <Flex mt='1rem'>
                <MiniDropdownInput
                  variant={
                    medicineType === "IVFluids" ? "leftSide" : ""
                  }
                  options={getOptionsByType(medicineType)}
                  placeholderProp={placeholder}
                  onSelect={handleChangeDosageUnit}
                  handleInputChange={(e) =>
                    setMedicineDosage(
                      validationOfNumberWithOnly1Decimal(e.target.value)
                    )
                  }
                  inputVal={dosage}
                  defaultOptionProp={dosageunit}
                  maxLength="6"
                />

                {medicineType === "IVFluids" && (
                  <MiniDropdownInput
                    variant="rightSide"
                    options={[
                      { label: "ml/hr", value: "ml/hr" },
                      { label: "ml/min", value: "ml/min" },
                    ]}
                    handleInputChange={(e) =>
                      setMedicineDosageUnit(
                        validationOfNumberWithOnly1Decimal(e.target.value)
                      )
                    }
                    placeholderProp="Rate of Infusion"
                    onSelect={handleChangeDosageMl}
                    maxLength="6"
                  />
                )}
              </Flex>
              <Flex>
                <PrimaryInput
                  variant="leftDown"
                  title="Drug Class"
                  inputPlace="Drug Class"
                  name="drugclass"
                  onChange={(e) => setDrugClass(e.target.value)}
                  inputValue={drugClass}
                />
                <PrimaryInput
                  variant="rightDown"
                  title="Therapeutic Category"
                  inputPlace="Therapeutic Category"
                  name="therapeutic"
                  onChange={(e) => setTherapeutic(e.target.value)}
                  inputValue={therapeutic}
                />
              </Flex>

              {/* <DropdownInput
                variant="downSide"
                dropDownPlace="Type"
                options={uniqueMedicineTypes}
                onClick={(selectedOption) =>
                  handleDropdownChange(selectedOption)
                }
              /> */}
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Add Generic Medication"
              onClick={() => addNewGenericMedicine(search)}
            />
          </>
        }
      />
      <DynamicModal
        ref={editgeneric}
        modalWidth={{ base: "100vw", lg: "calc(100vw - 50%)" }}
        modalHeader="Edit Generic Medication"
        modalBody={
          <>
            <Box display="flex" flexDir="column">
              <PrimaryInput
                // variant="leftSide"
                title="Composition (API)"
                inputPlace="Composition (API)"
                name="composition"
                onChange={(e) => setComposition(e.target.value)}
                inputValue={composition}
              />
              <RadioGroup
                mt="1rem"
                defaultValue={medicineType}
                onChange={handlemedicinetypechange}
              >
                <Stack direction="row" gap="20px" wrap="wrap">
                  {[
                    "Tablet",
                    "Capsule",
                    "Syrup",
                    "Injection",
                    "Ointment",
                    "Drops",
                    "Nebulization",
                    "IVFluids",
                    "Inhaler",
                  ].map((type) => (
                    <Radio key={type} colorScheme="green" value={type}>
                      {type === "Ointment" ? "Ointments / Creams / Gels" : type}
                    </Radio>
                  ))}
                </Stack>
              </RadioGroup>
              <Flex mt='1rem'>
                <MiniDropdownInput
                  variant={
                    medicineType === "IVFluids" ? "leftSide" : ""
                  }
                  options={getOptionsByType(medicineType)}
                  placeholderProp={placeholder}
                  onSelect={handleChangeDosageUnit}
                  handleInputChange={(e) =>
                    setMedicineDosage(
                      validationOfNumberWithOnly1Decimal(e.target.value)
                    )
                  }
                  inputVal={dosage}
                  defaultOptionProp={dosageunit}
                  maxLength="6"
                />

                {medicineType === "IVFluids" && (
                  <MiniDropdownInput
                    variant="rightSide"
                    options={[
                      { label: "ml/hr", value: "ml/hr" },
                      { label: "ml/min", value: "ml/min" },
                    ]}
                    handleInputChange={(e) =>
                      setMedicineDosageUnit(
                        validationOfNumberWithOnly1Decimal(e.target.value)
                      )
                    }
                    placeholderProp="Rate of Infusion"
                    onSelect={handleChangeDosageMl}
                    maxLength="6"
                  />
                )}
              </Flex>
              <Flex>
                <PrimaryInput
                  variant="leftDown"
                  title="Drug Class"
                  inputPlace="Drug Class"
                  name="drugclass"
                  onChange={(e) => setDrugClass(e.target.value)}
                  inputValue={drugClass}
                />
                <PrimaryInput
                  variant="rightDown"
                  title="Therapeutic Category"
                  inputPlace="Therapeutic Category"
                  name="therapeutic"
                  onChange={(e) => setTherapeutic(e.target.value)}
                  inputValue={therapeutic}
                />
              </Flex>

              {/* <DropdownInput
                variant="downSide"
                dropDownPlace="Type"
                options={uniqueMedicineTypes}
                onClick={(selectedOption) =>
                  handleDropdownChange(selectedOption)
                }
              /> */}
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Edit Generic Medication"
              onClick={editGenericMedicine}
            />
          </>
        }
      />

      <DynamicModal
        ref={deletegeneric}
        modalHeader="Delete Medicine?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete
              <strong> "{composition}"</strong>
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={() => deleteGenericMedicine(search.id)}
            />
          </>
        }
      />
    </>
  );
};

export default DrugDatabaseManagement;
